<template>
    <div class="ix-formbuilder-component-summary-content">
        <div v-if="displayMode == 'readable' || displayMode == 'fillable'" class="formbuilder-component boxed">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <label :for="index" class="formbuilder-component-label"  v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span style="white-space: pre-line">{{ currentField.value }}</span>
                    <div class="formbuilder-textarea-placeholder" v-if="currentField.inputType == 'textarea'"></div>
                </div>

                    <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <input v-if="currentField.inputType == 'text'" type="text" :name="index" :id="index" :placeholder="currentField.placeholder" class="form-control" v-model="currentField.value" :required="currentField.required">
                    <textarea v-if="currentField.inputType == 'textarea'" :placeholder="currentField.placeholder" class="form-control" v-model="currentField.value"  :required="currentField.required"></textarea>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Saisie de texte">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-pen-alt"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "TextComponent",
        props: ['currentField' , 'showIcon', 'displayMode', 'index'],
        data(){
            return {
                value : '',
            }
        },
        mounted() {
            if(this.displayMode == "readable"){
                this.currentField.value = this.currentField.value ? this.currentField.value : 'Non renseigné'
            }
        }
    }
</script>